module.exports = __webpack_public_path__ + "img/emaar.d69c837.svg";